export const META_CONFIG = {
  APP_ID: "1831076404169597",
  CONFIG_ID: "1667350971301797",
  get REDIRECT_URI() {
    return `${window.location.origin}/auth/meta-callback`;
  },
  SCOPE: "email,ads_management,ads_read,business_management,catalog_management,pages_manage_ads,pages_show_list",
  N8N_TOKEN_EXCHANGE_URL: "https://n8n.srv832423.hstgr.cloud/webhook/meta-oauth-exchange",
};
